import React, { useEffect } from 'react';
import { Modal, ModalContent, ModalFooter } from "../../components/ui/Modal";
import { Button } from "../../components/ui/Button";
import { HttpRequest } from "../../util/http";

interface IProps {
    open: boolean;
    isWowItem: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const WowItemModalComponent: React.FC<IProps> = (props) => {
    const [message, setMessage] = React.useState<string>('');
    const [confirmationButtonText, setConfirmationButtonText] = React.useState<string>('');
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    useEffect(() => {
        setMessage(props.isWowItem ? 'Do you really want to remove the Wow Item flag from this survey?' : 'Do you really want to add a Wow Item flag to this Survey?');
        setConfirmationButtonText(props.isWowItem ? 'Yes, Remove Flag' : 'Yes, Add Flag');
    }, [props.isWowItem]);

    const handleConfirm = async () => {
        setIsSubmitting(true);

        const url = new URL(window.location.href);
        const externalDataReference = url.searchParams.get('id');
        const surveyAbbreviation = url.searchParams.get('survey');

        const method = 'POST';
        const data = {
            externalDataReference: externalDataReference,
            surveyAbbreviation: surveyAbbreviation,
        };

        await HttpRequest.fetch(
            `/api/individual-surveys/${props.isWowItem ? 'remove-wow-flag' : 'add-wow-flag'}`,
            { data, method }
        ).then((res: any) => {
            if (res.success) {
                props.onConfirm();
                Materialize.toast(`${props.isWowItem ?
                    'Wow Item flag has been removed from this survey' :
                    'This survey has been flagged as a Wow Item'}`,
                    2500,
                    'toast-alert'
                );
                // @ts-ignore
                window.buildNoteTable(res.notes);
                //     emit event to window.opener to refresh the survey list
                if (window.opener) {
                    window.opener.postMessage(JSON.stringify({
                        data: 'updateWowItem',
                        edr: externalDataReference,
                    }), location.origin);
                }
            }
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setIsSubmitting(false);
            setTimeout(() => {
                props.onClose();
            }, 250);
        });
    };

    return (
        <Modal open={props.open}>
            <ModalContent>
                <header>
                    <h4>Confirm</h4>
                </header>
                <section>
                    {message}
                </section>
            </ModalContent>
            <ModalFooter>
                <Button type="button" color="danger" onClick={handleConfirm}>
                    {isSubmitting && <span>Submitting changes...</span>}
                    {!isSubmitting && <span>{confirmationButtonText}</span>}
                </Button>
                <Button type="button" color="white" onClick={props.onClose} disabled={isSubmitting}>
                    <span>Cancel</span>
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default WowItemModalComponent;